<script setup lang="ts">
const { t } = useI18n({
  useScope: 'local',
});
</script>

<template>
  <div class="message-box-faq">
    <div class="icon-wrapper-wrapper">
      <div class="icon-wrapper">
        <Icon name="bi:info-circle" class="icon" />
      </div>
    </div>

    <i18n-t keypath="call-to-action" tag="p">
      <template #link>
        <tw-ui-action is="link" variant="text-primary" to="/faq#ringtausch">
          {{ t('faq-link') }}
        </tw-ui-action>
      </template>
    </i18n-t>
  </div>
</template>

<style scoped lang="scss">
@import '~/assets/styles/tw-variables.scss';
@import '~/assets/styles/tw-mixins.scss';

.message-box-faq {
  display: flex;
  align-items: flex-start;
  gap: 1rem;

  .icon-wrapper-wrapper {
    display: flex;
    align-items: start;
    flex-direction: column;
  }

  .icon-wrapper {
    width: 1.4rem;
    height: 1.4rem;
    display: block;
    border-radius: 100%;
  }

  .icon {
    width: 100%;
    height: 100%;
    color: $gray;
  }

  p {
    margin: 0;
    color: #6c757d;
  }
  .action {
    color: #6c757d;
  }
}

</style>

<i18n lang="json">
{
  "de": {
    "call-to-action": "Du bist dir unsicher, wie der Ringtausch funktioniert? Kein Problem! Schau dir einfach unsere {link} an.",
    "faq-link": "Ringtausch FAQ"
  },
  "en": {
    "call-to-action": "Not sure how the ring swap works? No problem! Just check out our {link}.",
    "faq-link": "Ring swap FAQ"
  }
}
</i18n>
